import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import axiosInstance from '../../../../../axiosInstance';
import { API_URL } from "../../../../../config";
import { toast } from 'react-toastify';
import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";

function SectionCandidateSocialInfo() {
    const { t } = useTranslation();
    const [title, setTitle] = useState("");
    const [authorized, setAuthorized] = useState("");
    const [age, setAge] = useState("");
    const [experience, setExperience] = useState("");
    const [speak, setSpeak] = useState("");
    const [study, setStudy] = useState("");
    const [isNew, setIsNew] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await axiosInstance.get(`${API_URL}/screening-Questions`);
                const data = res.data?.data;
                if (data) {
                    setTitle(data.title || "");
                    setAuthorized(data.authorized_work_canada || "");
                    setAge(data.age || "");
                    setExperience(data.experience || "");
                    setSpeak(data.speak || "");
                    setStudy(data.study || "");
                    setIsNew(false);
                }
            } catch (error) {
                console.log("No existing data found. Switching to create mode.");
                setIsNew(true);
            }
        };
        fetchData();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const payload = {
            title,
            authorized_work_canada: authorized || null,
            age: age || null,
            experience: experience || null,
            speak: speak || null,
            study: study || null,
        };
        
        try {
            const url = isNew ? `${API_URL}/addScreeningQustion` : `${API_URL}/screeningQustion-Update`;
            const method = isNew ? 'post' : 'put';
            const res = await axiosInstance[method](url, payload);

            if (res.status === 200) {
                toast.success("Changes saved successfully");
                setIsNew(false);
            } else {
                toast.error(res.data?.message || "Something went wrong");
            }
        } catch (error) {
            console.error("Error saving data:", error);
            const errMsg = error.response?.data?.message || "Failed to save data";
            toast.error(errMsg);
        }
    };

    return (
        <div className="container mt-4">
            <div className="panel-heading wt-panel-heading p-a20 mb-4">
                <h4 className="panel-tittle m-a0">{t("Screening Questions")}</h4>
            </div>

            <Form onSubmit={handleSubmit}>
                {/* Headline */}
                <Form.Group className="mb-3">
                    <Form.Label>{t("Enter a brief title about your professional identity.")}</Form.Label>
                    <Form.Control
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        type="text"
                        placeholder={`${t("Marketing specialist with a focus on SEO")}`}
                    />
                </Form.Group>
                {/* Authorized */}
                <div className="d-flex align-items-center">
                    <label className="me-3">{t("Are you authorized to work in CANADA ?")}</label>
                </div>
                <div className="mb-3">
                    <Button
                        variant={authorized === "yes" ? "success" : "outline-success"}
                        className="me-2"
                        onClick={() => setAuthorized("yes")}
                    >
                        {t("Yes")}
                    </Button>
                    <Button
                        variant={authorized === "no" ? "danger" : "outline-danger"}
                        onClick={() => setAuthorized("no")}
                    >
                        {t("No")}
                    </Button>
                </div>
                {/* Age */}
                <div className="d-flex align-items-center">
                    <label className="me-3">{t("Are you between 25 and 50 years old ?")}</label>
                </div>
                <div className="mb-3">
                    <Button
                        variant={age === "yes" ? "success" : "outline-success"}
                        className="me-2"
                        onClick={() => setAge("yes")}
                    >
                        {t("Yes")}
                    </Button>
                    <Button
                        variant={age === "no" ? "danger" : "outline-danger"}
                        onClick={() => setAge("no")}
                    >
                        {t("No")}
                    </Button>
                </div>
                {/* Experience */}
                <div className="d-flex align-items-center">
                    <label className="me-3">{t("Do you have at least 2 years of experience in your profession ?")}</label>
                </div>
                <div className="mb-3">
                    <Button
                        variant={experience === "yes" ? "success" : "outline-success"}
                        className="me-2"
                        onClick={() => setExperience("yes")}
                    >
                        {t("Yes")}
                    </Button>
                    <Button
                        variant={experience === "no" ? "danger" : "outline-danger"}
                        onClick={() => setExperience("no")}
                    >
                        {t("No")}
                    </Button>
                </div>
                {/* Speak */}
                <div className="d-flex align-items-center">
                    <label className="me-3">{t("Do you speak French or English ?")}</label>
                </div>
                <div className="mb-3">
                    <Button
                        variant={speak === "yes" ? "success" : "outline-success"}
                        className="me-2"
                        onClick={() => setSpeak("yes")}
                    >
                        {t("Yes")}
                    </Button>
                    <Button
                        variant={speak === "no" ? "danger" : "outline-danger"}
                        onClick={() => setSpeak("no")}
                    >
                        {t("No")}
                    </Button>
                </div>
                {/* Study */}
                <div className="d-flex align-items-center">
                    <label className="me-3">{t("Do you have 11 years of recognized study ?")}</label>
                </div>
                <div className="mb-4">
                    <Button
                        variant={study === "yes" ? "success" : "outline-success"}
                        className="me-2"
                        onClick={() => setStudy("yes")}
                    >
                        {t("Yes")}
                    </Button>
                    <Button
                        variant={study === "no" ? "danger" : "outline-danger"}
                        onClick={() => setStudy("no")}
                    >
                        {t("No")}
                    </Button>
                </div>
                {/* Save Button */}
                <div className="col-lg-12 col-md-12">
                    <div className="text-left">
                        <button type="submit" className="site-button">{t("Save Changes")}</button>
                    </div>
                </div>
            </Form>
        </div>
    );
}

export default SectionCandidateSocialInfo;

